const GRID_Y = [260, 205, 150, 95, 40];
const Y_LABELS = [
	{ y: 264, label: "0%" },
	{ y: 209, label: "25%" },
	{ y: 154, label: "50%" },
	{ y: 99, label: "75%" },
	{ y: 44, label: "100%" },
];
const MONTHS = [
	"jan",
	"fev",
	"mar",
	"abr",
	"mai",
	"jun",
	"jul",
	"ago",
	"set",
	"out",
];
const PLAN =
	"50,260 107,251.2 164,238 221,216 278,187.4 335,156.6 392,125.8 449,97.2 506,70.8 563,51";
const REAL =
	"50,260 107,253.4 164,240.2 221,220.4 278,198.4 335,174.2 392,150 449,128 506,110.4";

export function SCurvePanel() {
	return (
		<figure
			data-slot="panel"
			aria-label="Curva S de avanço acumulado, planejado e realizado"
		>
			<div data-slot="panel-head">
				<b data-slot="panel-title">Curva S · avanço acumulado</b>
				<span data-slot="pill" data-variant="late">
					Abaixo do planejado
				</span>
			</div>
			<div data-slot="chart">
				<svg
					viewBox="0 0 600 290"
					role="img"
					aria-label="Planejado chega a 74% em setembro; realizado está em 68%"
				>
					<g data-slot="chart-grid">
						{GRID_Y.map((y) => (
							<line key={y} x1="50" x2="585" y1={y} y2={y} />
						))}
					</g>
					<g textAnchor="end">
						{Y_LABELS.map((tick) => (
							<text key={tick.label} x="42" y={tick.y}>
								{tick.label}
							</text>
						))}
					</g>
					<g textAnchor="middle">
						{MONTHS.map((month, index) => (
							<text key={month} x={50 + index * 57} y="282">
								{month}
							</text>
						))}
					</g>
					<polygon data-slot="chart-area" points={`${REAL} 506,260`} />
					<line
						data-slot="chart-today"
						x1="506"
						x2="506"
						y1="30"
						y2="260"
						strokeDasharray="3 3"
					/>
					<polyline
						data-slot="chart-plan"
						points={PLAN}
						strokeWidth={2.5}
						strokeDasharray="6 5"
					/>
					<polyline data-slot="chart-real" points={REAL} strokeWidth={3} />
					<circle
						data-slot="chart-dot-plan"
						cx="506"
						cy="70.8"
						r="5"
						strokeWidth={2.5}
					/>
					<circle
						data-slot="chart-dot"
						cx="506"
						cy="110.4"
						r="6"
						strokeWidth={3}
					/>
					<text data-slot="chart-label" x="496" y="66" textAnchor="end">
						74%
					</text>
					<text data-slot="chart-label" x="496" y="126" textAnchor="end">
						68%
					</text>
				</svg>
			</div>
			<div data-slot="legend">
				<span>
					<i data-slot="legend-swatch" />
					Realizado
				</span>
				<span>
					<i data-slot="legend-swatch" data-variant="plan" />
					Planejado
				</span>
				<span>Linha tracejada vertical: hoje</span>
			</div>
			<dl data-slot="stats">
				<div>
					<dt>Avanço realizado</dt>
					<dd>68%</dd>
				</div>
				<div>
					<dt>Desvio do planejado</dt>
					<dd data-variant="late">−6 p.p.</dd>
				</div>
				<div>
					<dt>Etapas atrasadas</dt>
					<dd data-variant="late">1</dd>
				</div>
			</dl>
		</figure>
	);
}
